<template>
    <div class="section footer">
      <div class="section__wrapper">
        <div class="section__content footer__content">
          <div class="footer__content-block mb-2">
            <a href="mailto:btab@tuimedia.com?subject=Britain Take A Bow" class="footer__label mr-3">Contact</a>
          </div>
          <div class="footer__content-block mb-2" v-if="showShare">
            <span class="footer__label mr-3">Share:</span>
            <img 
              v-sharer
              data-sharer="twitter"
              data-title="Britain, Take A Bow!"
              data-url="https://britaintakeabow.org"
              class="footer__social-icon mr-3"
              src="../assets/icon_twitter.svg"
              alt="Twitter icon"
            >
            <img 
              v-sharer
              data-sharer="facebook"
              data-url="https://britaintakeabow.org"
              class="footer__social-icon mr-3"
              src="../assets/icon_facebook.svg"
              alt="Facebook icon"
            >
            <img 
              v-sharer
              data-sharer="linkedin"
              data-url="https://britaintakeabow.org"
              class="footer__social-icon mr-3"
              src="../assets/icon_linkedin.svg"
              alt="LinkedIn icon"
            >
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import VueSharer from 'vue-sharer';

export default {
  name: 'app-footer',
  data() {
    return {
      shareRoutes: [
        'view-home',
        'view-video',
      ],
    };
  },
  directives: {
    sharer: VueSharer,
  },
  computed: {
    showShare() {
      return this.shareRoutes.indexOf(this.$route.name) > -1;
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppFooter.vue?659500f6